import { render } from "./MovieDetails.vue?vue&type=template&id=4c6a8a4f&scoped=true"
import script from "./MovieDetails.vue?vue&type=script&lang=js"
export * from "./MovieDetails.vue?vue&type=script&lang=js"

import "./MovieDetails.vue?vue&type=style&index=0&id=4c6a8a4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6a8a4f"]])

export default __exports__